const getOwnerReferenceId = (reference) => {
  if (reference && typeof reference === 'object') {
    return reference.id ?? reference.pma_id ?? reference.owner_id ?? null;
  }

  return reference ?? null;
};

export function getCalendarOwnerReferences(task) {
  const pluralOwners = [task?.owners, task?.owner_ids, task?.ownerIds]
    .find((value) => Array.isArray(value) && value.length > 0);
  const references = pluralOwners ?? [task?.owner_id ?? task?.owner].filter(Boolean);
  const uniqueReferences = new Map();

  references.forEach((reference) => {
    const id = getOwnerReferenceId(reference);
    if (id === null || id === undefined || String(id).trim() === '') return;

    const normalizedId = String(id);
    if (!uniqueReferences.has(normalizedId)) uniqueReferences.set(normalizedId, reference);
  });

  return Array.from(uniqueReferences.values());
}

export function getCalendarOwnerIds(task) {
  return getCalendarOwnerReferences(task).map((reference) => String(getOwnerReferenceId(reference)));
}

export function isCalendarOwner(task, pmaId) {
  if (pmaId === null || pmaId === undefined || String(pmaId).trim() === '') return false;
  return getCalendarOwnerIds(task).includes(String(pmaId));
}

export function getCalendarOwnerReferenceId(reference) {
  const id = getOwnerReferenceId(reference);
  return id === null || id === undefined ? null : String(id);
}
